import { useEffect, useState } from 'react';
import { supabase } from '../supabaseClient';

// ── ŞİRKETİN YEREL GÜNÜ — TEK KAYNAK (21 Eyl 2026) ──────────────────────────
//
// 🔑 Serkan: *"Ana üs yereli tabii ki — eğitim nerede alınırsa alınsın ana üs
//    yereli olur."* · *"Şirket nerdeyse eğitim zamanları oraya göre tutulur;
//    pilotun home base'i başka şehir olabilir çok uçaklı ve pilotlu yapılarda,
//    şirket eğitimi kendi lokaline göre takip eder."*
//    → Ölçü ŞİRKETİN ana üssü, pilotun değil. Bu yüzden tek dilim yeter.
//
// DAYANAK: geçerlilik bir TARİHtir — ORO.FC.230(g) *"kontrolün yapıldığı ayın
// sonundan itibaren"*, FCL.740, MED.A.045. Hesabın tamamı zaten dizge üzerinde
// yürüyor (`TrainingRules`: *"saat dilimi kayması olmasın diye Date nesnesine
// hiç girilmez"*). Dilim YALNIZ "bugün hangi gün" sorusuna giriyor — burası.
//
// 🔴 ÖNCESİ: `todayLocal()` cihazın yerelini kullanıyordu, yani cevap EKRANA
//    NEREDEN BAKILDIĞINA bağlıydı. Yurtdışından bakan bir yönetici, gün
//    sınırında aynı kayda bir gün farklı görebilirdi.
//
// 🔑 OTURUM BAŞINA TEK ÇÖZÜM: şirketin ana üssü bir oturum içinde değişmez.
//    Beş bileşen ayrı ayrı sorsaydı beş sorgu olurdu; söz (promise) paylaşılır.
//
// 🔴 21 EYL 2026 — KAPSAM EKLENDI. Süper admin BAŞKA bir şirketi izleyebiliyor
//    (`scopeCustomerId`); argümansız çözüm her zaman GİRİŞ YAPANIN şirketini
//    verir. FTL panelinde vekil dilim olarak kullanılınca bu, izlenen şirketin
//    boş günlerini KENDİ şirketimizin diliminde ölçmek olurdu. Argüman verilirse
//    o şirket çözülür; verilmezse davranış aynen eskisi gibi kalır.
const sozler = new Map();       // customerId | '__kendi__' → Promise

/** Önbelleği boşaltır — oturum değişince (`oturumDegisti`) ve testlerde. */
export function sirketDilimiSifirla() { sozler.clear(); }

// 🔴 21 EKİ 2026 (K20) — ÇIKIŞ SAYFAYI YENİLEMİYOR: LOGOUT yalnız giriş ekranına döner, modül ayakta kalır. '__kendi__'
//    ("giriş yapanın şirketi") önbellekte kaldığı için aynı sekmede BAŞKA ŞİRKETTEN biri girince TRAINING, ATPL & MED,
//    zil ve EFB rozeti günü sayfa yenilenene kadar ÖNCEKİ şirketin ana üssüne göre sayardı. Oturumun sahibi değişince
//    (çıkış, oturum süresinin dolması, başka kullanıcı) önbellek boşalır; token yenilemede (aynı kişi) dokunulmaz.
//    Çağıran tek yer: `App.js`teki oturum dinleyicisi.
let oturumSahibi;
/** @param {string|null} kullaniciId  yeni oturumun kullanıcısı (oturum yoksa null) */
export function oturumDegisti(kullaniciId) {
  const kim = kullaniciId || null;
  if (kim !== oturumSahibi) { sirketDilimiSifirla(); oturumSahibi = kim; }
}

// 🔴 14 EKİ 2026 — OKUNAMADI ≠ YOK (Serkan, saha: "HOME BASE NOT SET" çıktı, sayfayı yenileyince kalktı; veri doğruydu —
//    REC · LTAC · Europe/Istanbul). Dört okumanın hiçbirinin `error`ü okunmuyordu ve sonuç oturum boyunca önbellekte
//    kalıyordu: tek bir düşen okuma (oturum yenileme, ağ) bütün oturum "ana üs girilmemiş" yalanına dönüyordu.
//    Artık: { durum:'hazir' } · { durum:'yok' } (gerçekten girilmemiş / meydan listede yok / dilim bozuk) ·
//    { durum:'okunamadi', adim } (hangi okuma düştü) — düşen sonuç ÖNBELLEĞE YAZILMAZ, ekran bir sonraki açılışta
//    yeniden dener; o ana kadar ekran "sayfayı yenile" der (Serkan: *"uyarı çıktığında advice olarak sayfayı yenile desin"*).
async function coz(customerId = null) {
  const okunamadi = (adim) => ({ durum: 'okunamadi', adim });
  let hedef = customerId;
  if (!hedef) {
    const { data: oturum, error: oErr } = await supabase.auth.getUser();
    const user = oturum?.user;
    if (oErr || !user) return okunamadi('SIGN-IN CHECK');
    const { data: prof, error: pErr } = await supabase.from('profiles')
      .select('customer_id').eq('id', user.id).maybeSingle();
    if (pErr || !prof?.customer_id) return okunamadi('USER PROFILE');
    hedef = prof.customer_id;
  }
  const { data: cust, error: cErr } = await supabase.from('customers')
    .select('home_base_icao').eq('id', hedef).maybeSingle();
  if (cErr || !cust) return okunamadi('COMPANY RECORD');
  const icao = String(cust.home_base_icao || '').toUpperCase();
  // Ana üs yoksa ya da meydan tanınmıyorsa UYDURMAYIZ — 'yok' döner ve çağıran
  // bunu EKRANDA SÖYLER. Sessizce cihaz saatine düşmek İlke 1 ihlali olurdu.
  if (!/^[A-Z]{4}$/.test(icao)) return { durum: 'yok' };
  const { data: apt, error: aErr } = await supabase.from('airports')
    .select('tz').eq('icao', icao).maybeSingle();
  if (aErr) return okunamadi('AIRPORT LIST');
  if (!apt?.tz) return { durum: 'yok' };
  // 🔴 DİLİM ADINI BURADA DENERİZ: `airports.tz` bozuk bir değer taşıyorsa
  //    (elle düzeltilmiş satır, eski göç) her ekranda ayrı ayrı patlardı.
  //    Bir kez denenir; tutmazsa 'yok' döner ve ekranda bant çıkar —
  //    sessizce cihaz saatine düşmek İlke 1 ihlali olurdu.
  try { new Date().toLocaleDateString('sv-SE', { timeZone: apt.tz }); }
  catch { return { durum: 'yok' }; }
  return { durum: 'hazir', tz: apt.tz, icao };
}

/** @param {string|null} customerId  Verilmezse GİRİŞ YAPANIN şirketi çözülür.
 *  @returns {{durum:'okunuyor'|'hazir'|'yok'|'okunamadi', tz:string|null, icao:string|null, adim:string|null}} */
export function useSirketDilimi(customerId = null) {
  const [d, setD] = useState({ durum: 'okunuyor', tz: null, icao: null, adim: null });
  useEffect(() => {
    let dead = false;
    const anahtar = customerId || '__kendi__';
    if (!sozler.has(anahtar)) sozler.set(anahtar, coz(customerId));
    const soz = sozler.get(anahtar);
    // Düşen okuma önbellekte KALMAZ — ekran bir sonraki açılışta yeniden sorar (14 Eki 2026).
    const unut = () => { if (sozler.get(anahtar) === soz) sozler.delete(anahtar); };
    soz
      .then(r => {
        if (r?.durum === 'okunamadi') unut();
        if (!dead) setD({ tz: null, icao: null, adim: null, ...r });
      })
      .catch(() => { unut(); if (!dead) setD({ durum: 'okunamadi', tz: null, icao: null, adim: 'CONNECTION' }); });
    return () => { dead = true; };
  }, [customerId]);
  return d;
}

/** Ana üs gerçekten girilmemiş (ya da meydan listede yok) — ekranda görünecek cümle; sessiz düşüş yok. */
export const DILIM_YOK_METNI =
  'HOME BASE NOT SET — validity dates are shown in this device\'s local time';

/** EKRAN UYARISI — tek kaynak (14 Eki 2026): girilmemiş ile okunamamış AYRI cümle; okunamadıysa ne yapılacağı da. */
export function dilimUyarisi(d) {
  if (d?.durum === 'yok') return DILIM_YOK_METNI;
  if (d?.durum === 'okunamadi') {
    return `HOME BASE COULD NOT BE READ (${d.adim || 'CONNECTION'}) — REFRESH THE PAGE. `
      + 'Until then, validity dates are shown in this device\'s local time.';
  }
  return null;
}
